var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H11.3333C12.4379 0 13.3333 0.895431 13.3333 2V8C13.3333 9.10457 12.4379 10 11.3333 10H2C0.89543 10 0 9.10457 0 8V2C0 0.895431 0.89543 0 2 0ZM5.33333 6.66667H3.33333C2.96514 6.66667 2.66667 6.36819 2.66667 6C2.66667 5.63181 2.96514 5.33333 3.33333 5.33333H5.33333C5.70152 5.33333 6 5.63181 6 6C6 6.36819 5.70152 6.66667 5.33333 6.66667ZM12 8C12 8.36819 11.7015 8.66667 11.3333 8.66667H2C1.63181 8.66667 1.33333 8.36819 1.33333 8V4H12V8ZM1.33333 2.66667H12V2C12 1.63181 11.7015 1.33333 11.3333 1.33333H2C1.63181 1.33333 1.33333 1.63181 1.33333 2V2.66667Z",
    fill: "#2E5DE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCard);
export default __webpack_public_path__ + "static/media/blue-card.01759936280f6d99cfa4f0d77f27ffdd.svg";
export { ForwardRef as ReactComponent };